import {gql} from "@apollo/client";

export const AddCaseStudy = gql`
  mutation AddCaseStudy(
    $token: String!
    $customerID: ID!
    $user_details: SubscribedUser!
    $input: CreateCaseStudies!
  ) {
    AddCaseStudy(
      token: $token
      customerID: $customerID
      user_details: $user_details
      input: $input
    ) {
      id
    }
  }
`;

export const UpdateCaseStudy = gql`
  mutation UpdateCaseStudy(
    $token: String!
    $user_details: SubscribedUser!
    $caseStudyID: ID!
    $input: UpdateCaseStudies!
  ) {
    UpdateCaseStudy(
      token: $token
      user_details: $user_details
      caseStudyID: $caseStudyID
      input: $input
    ) {
      id
    }
  }
`;

export const DeleteCaseStudy = gql`
  mutation DeleteCaseStudy(
    $token: String!
    $caseStudyID: ID!
    $user_details: SubscribedUser!
  ) {
    DeleteCaseStudy(
      token: $token
      caseStudyID: $caseStudyID
      user_details: $user_details
    )
  }
`;
